export default [
    {
        path: '/media-gallery',
        name: 'media-gallery-read',
        component: () => import('@/views/mediaGallery/media-list/MediaGalleryList.vue'),
        meta: {
            resource: 'Media Gallery',
            action: 'read',
        }
    },
    {
        path: '/media-gallery/create',
        name: 'media-gallery-create',
        component: () => import('@/views/mediaGallery/MediaGalleryForm.vue'),
        meta: {
          resource: 'Media Gallery',
          action: 'create',
        },
    },
]